import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"

interface LoadingSpinnerProps {
  isFullPage?: boolean
  size: number
  isConversation?: boolean
  className?: string
}

export const LoadingSpinner = ({
  isFullPage = false,
  size = 24,
  isConversation = false,
  className,
}: LoadingSpinnerProps) => {
  const { t } = useTranslation()
  return (
    <div className={cn({ "flex h-full w-full items-center justify-center": isFullPage }, className)}>
      {isConversation && <span className="mr-2 text-xs"> {t("chat.conversation.loading")}</span>}
      <svg xmlns="http://www.w3.org/2000/svg" className="animate-spin" width={size} height={size}>
        <path
          className="fill-primary"
          d="M19 12c0-3.976-3.024-7-7-7V3a9 9 0 0 1 9 9h-2ZM12 19c3.976 0 7-3.024 7-7h2a9 9 0 0 1-9 9v-2ZM5 12c0 3.976 3.024 7 7 7v2a9 9 0 0 1-9-9h2Z"
        />
      </svg>
    </div>
  )
}
